import React, { useState } from 'react';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useLocation, useHistory } from 'react-router-dom';

import CTAButton from '../partials/components/ctaButton';
import RoundedContainer from '../partials/components/roundedContainer';


const RegionChange = ({ ...props }) => {
    const history = useHistory();
    const [region, setCurrentRegion] = useState(props.data.attendee.location);

    const non_regional = 'Non-Regional';
    const regions = props.data.attendee.possible_locations.concat(non_regional);
    const regions_type = 'group';
    
    const postRegionChange = () => {
        const newRegion = region == non_regional ? non_regional : region;
        fetch(`${launchframe.ajax_url}?action=update_user_${regions_type}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `${regions_type}=${newRegion}`
        })
            .then(res => res.json())
            .then(
                result => {
                    location.reload();
                },
                error => {
                    alert('Your location could not be changed.');
                }
            );
    };


    const regionOptions = regions.map((item, i) => {
        return (
            <MenuItem 
                key={i}
                value={item}
            >{item}</MenuItem>
        );
    });

    const handleChange = (event) => {
        setCurrentRegion(event.target.value);
    };

    return (
        <div className="flex px-4 py-10 font-sans container">
        <div className="w-full items-center text-center pb-2 sm:pb-8 ">
                {
                    props.data.attendee.location ?
                    <div className="text-lg sm:text-2xl font-sans font-bold">Current Region: <p className='text-red-500 text-md sm:text-xl'>{props.data.attendee.location}</p></div>
                    : ''
                }
                <br/>
                
                <RoundedContainer className="flex-wrap" yPadding="8">
                    <p className="w-full text-lg sm:text-2xl font-sans font-bold">Would you like to join a different location?</p>
                    <div className="w-full flex flex-col sm:flex-row flex-wrap justify-center items-center text-center">
                        <FormControl>
                            <Select
                                aria-label="regions"
                                name="regions"
                                value={region}
                                onChange={handleChange}
                                >
                                {regionOptions}
                            </Select>
                        </FormControl>
                    </div>
                </RoundedContainer>
                
                <div className="flex pt-16 px-4 justify-center items-center">
                    <CTAButton
                        text="Submit Change"
                        toggled={true}
                        onButtonClick={() => {
                            postRegionChange();
                        }}
                    />
                </div>
              
        </div>
       
        
    </div>
    );
};

export default RegionChange;
